var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import { Project as ProjectModel, ProjectIncludes } from '@/models/Project';
import PageHeader from '@/components/page-header/PageHeader';
import ErrorHandler from '@/support/ErrorHandler';
import { TabsColorEnum } from '@/config/theme';
let Project = class Project extends Vue {
    constructor() {
        // #endregion
        super(...arguments);
        // File structure for Typescript files in your Vue project
        // https://tutorials.atabix.com/frontend/typscript_file_structure/
        // #region @Props
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.$pageTitle = 'Project';
        // protected activeTab: string = 'profile';
        this.activeTab = '';
        this.isEdittingDescription = false;
        this.project = null;
        // #endregion
        // #region @Watchers
        // #endregion
    }
    // #region Getters & Setters
    get descriptionPayload() {
        return {
            description: (this.project && this.project.description) || '',
        };
    }
    get breadcrumbs() {
        const projectName = this.project && this.project.name ? this.project.name : '';
        return [{ name: this.$tc('projects.title', 2), path: '/projects' }, { name: projectName ? projectName.toString() : '', path: this.$route.path }];
    }
    get tabs() {
        return [
            {
                description: 'string',
                icon: 'home',
                is_visible: true,
                label: 'HOME',
                to: `/projects/${this.project ? this.project.id : ''}`,
            },
            {
                color: TabsColorEnum.LIGHT_BLUE,
                description: `${this.$tc('navigationCard.project.subjects')}`,
                icon: 'flag',
                is_visible: true,
                label: this.$tc('projects.tabs.subjects'),
                to: `/projects/${this.project ? this.project.id : ''}/subjects`,
            },
            {
                color: TabsColorEnum.LIGHT_GREEN,
                description: `${this.$tc('navigationCard.project.notes')}`,
                icon: 'speaker_notes',
                is_visible: true,
                label: this.$tc('projects.tabs.notes'),
                to: `/projects/${this.project ? this.project.id : ''}/notes`,
            },
            {
                color: TabsColorEnum.ORANGE,
                description: `${this.$tc('navigationCard.project.projectPlan')}`,
                icon: 'folder',
                is_visible: true,
                label: this.$tc('projects.tabs.project_plan'),
                to: `/projects/${this.project ? this.project.id : ''}/project-plan`,
            },
            {
                color: TabsColorEnum.RED,
                description: `${this.$tc('navigationCard.project.media')}`,
                icon: 'perm_media',
                is_visible: true,
                label: this.$tc('projects.tabs.media'),
                to: `/projects/${this.project ? this.project.id : ''}/media`,
            },
            // {
            //   color: TabsColorEnum.PURPLE,
            //   description: `${this.$tc('navigationCard.project.files')}`,
            //   icon: 'article',
            //   is_visible: true,
            //   label: this.$tc('projects.tabs.files'),
            //   to: `/projects/${this.project ? this.project.id : ''}/files`,
            // },
            {
                color: TabsColorEnum.YELLOW,
                description: `${this.$tc('navigationCard.project.messenger')}`,
                icon: 'question_answer',
                is_visible: true,
                label: this.$tc('navigationCard.project.titles.messenger'),
                to: `/projects/${this.project ? this.project.id : ''}/messenger`,
            },
        ];
    }
    // #endregion
    // #region Lifecycle Hooks / Init
    mounted() {
        this.initialize();
    }
    async initialize() {
        await this.getProject();
    }
    async updateDescription() {
        if (!this.project) {
            this.closeEditMode();
            return;
        }
        this.project
            .update(this.descriptionPayload)
            .then((project) => {
            if (this.project) {
                this.project.description = project.description;
            }
            this.closeEditMode();
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    tabStyle(tab) {
        if (!tab) {
            return;
        }
        if (!tab.color) {
            return;
        }
        if (this.isActiveTab(tab)) {
            return {
                backgroundColor: tab.color,
            };
        }
        return {
            borderBottom: `4px solid ${tab.color}`,
        };
    }
    // #endregion
    // #region Class methods
    startEditMode() {
        this.isEdittingDescription = true;
    }
    closeEditMode() {
        this.descriptionPayload.description = (this.project && this.project.description) || '';
        this.isEdittingDescription = false;
    }
    // #endregion
    // #region Async methods
    async getProject() {
        this.project = await new ProjectModel()
            .include([
            ProjectIncludes.AUDIT,
            ProjectIncludes.CHAT,
            ProjectIncludes.USERS,
            ProjectIncludes.SUBJECTS,
            ProjectIncludes.ROLES,
            ProjectIncludes.PARENT,
            ProjectIncludes.NOTES,
            ProjectIncludes.LEVEL,
        ])
            .find(this.$route.params.id);
    }
    isActiveTab(tab) {
        return tab && tab.to && this.activeTab === tab.to;
    }
    onMouseOver(event, tab) {
        document.documentElement.style
            .setProperty('--hover-color', tab.color || 'transparent');
    }
};
Project = __decorate([
    Component({
        components: {
            PageHeader,
        },
    })
], Project);
export default Project;
